(function(){
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true" class="mnav-chev"><polyline points="9 6 15 12 9 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(){
    var nav = document.querySelector('.category-nav');
    var headerInner = document.querySelector('.main-header__inner');
    var actions = document.querySelector('.header-actions');
    if(!nav || !headerInner || nav.dataset.mnavDone) return;
    nav.dataset.mnavDone = '1';

    var btn = document.createElement('button');
    btn.className = 'mnav-toggle';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Menü öffnen');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    if(actions) actions.insertBefore(btn, actions.firstChild);
    else headerInner.appendChild(btn);

    var backdrop = document.createElement('div');
    backdrop.className = 'mnav-backdrop';

    var panel = document.createElement('nav');
    panel.className = 'mnav-panel';
    panel.setAttribute('aria-label', 'Sortiment');
    panel.innerHTML =
      '<div class="mnav-panel__head"><strong>Sortiment</strong>' +
      '<button class="mnav-close" type="button" aria-label="Menü schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
      '<div class="mnav-panel__links"></div>';
    var wrap = panel.querySelector('.mnav-panel__links');

    var allLink = nav.querySelector('.category-nav__all');
    if(allLink){
      var a0 = document.createElement('a');
      a0.href = allLink.getAttribute('href');
      a0.className = 'mnav-flat mnav-flat--all';
      a0.textContent = 'Alle Kategorien';
      wrap.appendChild(a0);
    }

    nav.querySelectorAll('.catnav-item').forEach(function(item){
      var main = item.querySelector('.catnav-link');
      if(!main) return;
      var subs = item.querySelectorAll('.catnav-flyout__grid a');
      var mainLabel = main.getAttribute('data-full') || main.textContent.trim();

      if(subs.length === 0){
        var flat = document.createElement('a');
        flat.href = main.getAttribute('href');
        flat.className = 'mnav-flat';
        flat.textContent = mainLabel;
        wrap.appendChild(flat);
        return;
      }

      var group = document.createElement('div');
      group.className = 'mnav-group';
      var head = document.createElement('div');
      head.className = 'mnav-grouphead';
      var hlink = document.createElement('a');
      hlink.href = main.getAttribute('href');
      hlink.textContent = mainLabel;
      var exp = document.createElement('button');
      exp.type = 'button';
      exp.className = 'mnav-expand';
      exp.setAttribute('aria-label', 'Unterkategorien anzeigen');
      exp.setAttribute('aria-expanded', 'false');
      exp.innerHTML = CHEV;
      head.appendChild(hlink);
      head.appendChild(exp);
      group.appendChild(head);

      var sub = document.createElement('div');
      sub.className = 'mnav-sub';
      subs.forEach(function(s){
        var sa = document.createElement('a');
        sa.href = s.getAttribute('href');
        sa.textContent = s.textContent.trim();
        sub.appendChild(sa);
      });
      group.appendChild(sub);
      wrap.appendChild(group);

      exp.addEventListener('click', function(){
        var open = group.classList.toggle('open');
        exp.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    function open(){ panel.classList.add('open'); backdrop.classList.add('open'); btn.setAttribute('aria-expanded','true'); document.body.classList.add('mnav-open'); }
    function close(){ panel.classList.remove('open'); backdrop.classList.remove('open'); btn.setAttribute('aria-expanded','false'); document.body.classList.remove('mnav-open'); }
    btn.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    panel.querySelector('.mnav-close').addEventListener('click', close);
    wrap.addEventListener('click', function(e){ if(e.target.closest('a')) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
